import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable, throwError } from 'rxjs';
import { catchError } from 'rxjs/operators';
import { environment } from '../../../environments/environment';

export interface TipoExamenRecord {
  id?: number;
  nombre: string;
  descripcion?: string | null;
  estado?: 'ACTIVO' | 'INACTIVO' | string;
  fecha_creacion?: Date | string;
  fecha_modificacion?: Date | string;
}

@Injectable({
  providedIn: 'root'
})
export class TiposExamenService {
  private apiUrl = `${environment.apiUrl}/api/tipos-examen`;

  constructor(private http: HttpClient) {}

  getTiposExamen(): Observable<any> {
    return this.http.get<any>(this.apiUrl, { withCredentials: true }).pipe(
      catchError(error => throwError(() => error))
    );
  }

  getTiposExamenActivos(): Observable<any> {
    return this.http.get<any>(`${this.apiUrl}/activos`, { withCredentials: true }).pipe(
      catchError(error => throwError(() => error))
    );
  }

  getTiposExamenByEstado(estado: string): Observable<any> {
    return this.http.get<any>(`${this.apiUrl}/estado/${estado}`, { withCredentials: true }).pipe(
      catchError(error => throwError(() => error))
    );
  }

  getTipoExamenById(id: string | number): Observable<any> {
    return this.http.get<any>(`${this.apiUrl}/${id}`, { withCredentials: true }).pipe(
      catchError(error => throwError(() => error))
    );
  }

  createTipoExamen(payload: TipoExamenRecord): Observable<any> {
    return this.http.post<any>(this.apiUrl, payload, { withCredentials: true }).pipe(
      catchError(error => throwError(() => error))
    );
  }

  updateTipoExamen(id: string | number, payload: TipoExamenRecord): Observable<any> {
    return this.http.put<any>(`${this.apiUrl}/${id}`, payload, { withCredentials: true }).pipe(
      catchError(error => throwError(() => error))
    );
  }

  activarTipoExamen(id: string | number): Observable<any> {
    return this.http.patch<any>(`${this.apiUrl}/${id}/activar`, {}, { withCredentials: true }).pipe(
      catchError(error => throwError(() => error))
    );
  }

  inactivarTipoExamen(id: string | number): Observable<any> {
    return this.http.patch<any>(`${this.apiUrl}/${id}/inactivar`, {}, { withCredentials: true }).pipe(
      catchError(error => throwError(() => error))
    );
  }

  deleteTipoExamen(id: string | number): Observable<any> {
    return this.http.delete<any>(`${this.apiUrl}/${id}`, { withCredentials: true }).pipe(
      catchError(error => throwError(() => error))
    );
  }
}